/**
 * MantenimientoGate — pantalla completa de mantenimiento.
 *
 * Aparece cuando el backend responde 503 { codigo: "mantenimiento" } (candado OS_ACCESO_RESTRINGIDO:
 * solo las personas habilitadas usan el OS durante la ventana de pruebas). api/client.js dispara el
 * evento "crew-maintenance" con la hora estimada de vuelta. Nunca se confunde con una caída real
 * (esas no traen el código). No toca datos ni sesión: al reintentar se recarga la app. Reintenta solo
 * cada 60 segundos.
 */
import { useEffect, useState } from "react";
import { PaginaMantenimiento } from "./sistema/PaginasSistema.jsx";

const REINTENTO_MS = 60 * 1000;

export default function MantenimientoGate() {
  const [estado, setEstado] = useState(null); // { vuelve }

  useEffect(() => {
    const on = (e) => setEstado({ vuelve: e?.detail?.vuelve || "23:30" });
    window.addEventListener("crew-maintenance", on);
    return () => window.removeEventListener("crew-maintenance", on);
  }, []);

  useEffect(() => {
    if (!estado) return;
    const t = setTimeout(() => window.location.reload(), REINTENTO_MS);
    return () => clearTimeout(t);
  }, [estado]);

  if (!estado) return null;
  return (
    <div role="alertdialog" aria-modal="true" aria-label="SOA 10 PRO en mantenimiento"
         style={{ position: "fixed", inset: 0, zIndex: 10000 }}>
      <PaginaMantenimiento vuelve={estado.vuelve} />
    </div>
  );
}
